// src/Components/ProtectedRoute.js
import React, { useContext } from 'react';
import { Route, Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from './../Contextapi/ContextApi'; 

const ProtectedRoute = () => {
  const { userId  } = useContext(AuthContext);

  return userId  ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;